// (() => {
//     var t, r = {};
//     ! function t() {
//         var r = document.querySelector(".js-recommended-products"),
//             e = !1;
//         if (r.hasAttribute("data-flickity") && (e = !0), r) {
//             var o = parseInt(r.getAttribute("data-product-id"));
//             fetch(window.Shopify.routes.root + "recommendations/products.json?product_id=".concat(o, "&limit=5")).then(function(t) {
//                 return t.json()
//             }).then(function(t) {
//                 var o = t.products;
//                 o.length < 5 && r.classList.add("hide-arrows"), o.forEach(function(t, n) {
//                     fetch(window.Shopify.routes.root + "products/".concat(t.handle, "?view=card")).then(function(t) {
//                         return t.text()
//                     }).then(function(t) {
//                         var c = r.querySelector(".flickity-slider");
//                         c ? c.innerHTML += t : r.innerHTML += t, n === o.length - 1 && e && c && setTimeout(function() {
//                             var t = Flickity.data(".js-recommended-products");
//                             t.reloadCells(), t.resize()
//                         }, 1e3)
//                     })
//                 })
//             }).catch(function(t) {
//                 console.error("Error:", t)
//             })
//         }
//     }()
// })();




(() => {
    // Function to load recommended products
    function renderRecommendedProducts() {
        const recommendedContainer = document.querySelector(".js-recommended-products");

        if (recommendedContainer) {
            let hasFlickity = false;

            if (recommendedContainer.hasAttribute("data-flickity")) {
                hasFlickity = true;
            }

            const currentProductId = parseInt(recommendedContainer.getAttribute("data-product-id"));

            fetch(`${window.Shopify.routes.root}recommendations/products.json?product_id=${currentProductId}&limit=5`)
                .then(response => response.json())
                .then(data => {
                    const recommendedProducts = data.products;

                    if (recommendedProducts.length < 5) {
                        recommendedContainer.classList.add("hide-arrows");
                    }

                    recommendedProducts.forEach((product, index) => {
                        fetch(`${window.Shopify.routes.root}products/${product.handle}?view=card`)
                            .then(response => response.text())
                            .then(html => {
                                const flickitySlider = recommendedContainer.querySelector(".flickity-slider");

                                if (flickitySlider) {
                                    flickitySlider.innerHTML += html;
                                } else {
                                    recommendedContainer.innerHTML += html;
                                }

                                if (index === recommendedProducts.length - 1 && hasFlickity && flickitySlider) {
                                    setTimeout(() => {
                                        const flickityInstance = Flickity.data(".js-recommended-products");
                                        flickityInstance.reloadCells();
                                        flickityInstance.resize();
                                    }, 1000);
                                }
                            });
                    });
                })
                .catch(error => {
                    console.error("Error:", error);
                });
        }

        // Initialize swatches after 1s
        setTimeout(() => {
            // renderSwatches();
            c();
        }, 1000);
    }

    // Function to build swatches
    // function buildColourSwatches(collectionData, currentProductId, containerElement) {
    //     let swatchHTML = '<div class="product-colours">';
    //     let uniqueColours = [];
    //     let currentColour = null;

    //     let products = Object.values(collectionData.products);

    //     // Sort by size
    //     products.sort((a, b) => parseInt(a.size) - parseInt(b.size));

    //     products.forEach(product => {
    //         const productId = parseInt(product.id);
    //         const colour = product.colour;
    //         const url = product.url;
    //         const size = product.size;

    //         if (productId === currentProductId) {
    //             currentColour = colour;
    //         }

    //         const existingIndex = uniqueColours.findIndex(item => item.colour === colour);
    //         if (existingIndex === -1) {
    //             uniqueColours.push({ colour, url, size });
    //         }
    //     });

    //     uniqueColours.forEach(colourObj => {
    //         let swatchClass = `btn-colour-swatch ${colourObj.colour.toLowerCase()} h-6 w-6 rounded border border-gray-100 mr-2.5 cursor-pointer`;
    //         if (swatchClass.includes(currentColour)) {
    //             swatchClass += " current";
    //         }
    //         swatchHTML += `<a href="${colourObj.url}" class="${swatchClass}"></a>`;
    //     });

    //     swatchHTML += "</div>";
    //     containerElement.querySelector(".title").insertAdjacentHTML("afterend", swatchHTML);
    // }

    // // Function to fetch swatches
    // function renderSwatches() {
    //     const colourContainers = document.querySelectorAll(".product-card-colours-container");

    //     if (colourContainers) {
    //         colourContainers.forEach(container => {
    //             const colourGroup = container.getAttribute("data-colour-group");
    //             const currentProductId = parseInt(container.getAttribute("data-current-product-id"));

    //             if (colourGroup) {
    //                 const request = new XMLHttpRequest();
    //                 request.onreadystatechange = function () {
    //                     if (this.readyState === 4 && this.status === 200) {
    //                         let jsonResponse = null;
    //                         try {
    //                             jsonResponse = JSON.parse(this.responseText);
    //                         } catch (error) {
    //                             jsonResponse = null;
    //                         }
    //                         if (jsonResponse) {
    //                             buildColourSwatches(jsonResponse, currentProductId, container);
    //                         }
    //                     }
    //                 };
    //                 request.open("GET", `/collections/all/${colourGroup}?view=swatch`, true);
    //                 request.send();
    //             }
    //         });
    //     }
    // }
    function e(r, t, e) {
            var c = '<div class="product-colours">',
                o = [],
                n = [],
                i = Object.values(r.products);
            i.sort(function(r, t) {
                return parseInt(r.size) - parseInt(t.size)
            });
            for (var u = 0; u < i.length; u++) {
                var a = parseInt(i[u].id),
                    s = i[u].colour,
                    l = i[u].url,
                    d = i[u].size,
                    f = o.findIndex(function(r) {
                        return r.colour === s
                    });
                if (a === t) var h = s; - 1 == f && o.push({
                    colour: s,
                    url: l,
                    size: d
                }), n.push({
                    id: a,
                    colour: s,
                    url: l,
                    size: d
                })
            }
            o.forEach(function(r) {
                var t = "btn-colour-swatch " + r.colour.toLowerCase() + " h-6 w-6 rounded border border-gray-100 mr-2.5 cursor-pointer";
                t.includes(h) && (t += " current"), c += '<a href="' + r.url + '" class="' + t + '"></a>'
            }), c += "</div>", e.querySelector(".title").insertAdjacentHTML("afterend", c)
        }

        function c() {
            var r = document.querySelectorAll(".product-card-colours-container");
            r && r.forEach(function(r) {
                var t = r.getAttribute("data-colour-group"),
                    c = parseInt(r.getAttribute("data-current-product-id"));
                if (t) {
                    var o = new XMLHttpRequest;
                    o.onreadystatechange = function() {
                        if (4 == this.readyState && 200 == this.status) {
                            var t = this.responseText;
                            if (t) try {
                                var o = JSON.parse(t)
                            } catch (n) {
                                var o = null
                            }
                            o && e(o, c, r)
                        }
                    }, o.open("GET", "/collections/all/" + t + "?view=swatch", !0), o.send()
                }
            })
        }
    // Run only if container exists
    if (document.querySelector(".js-recommended-products")) {
        renderRecommendedProducts();
    }
})();
